import { useQuery } from '@tanstack/react-query';
import { useBlockchainService } from './blockchain-service';
export const useContractQuery = (options, ...args) => {
    const blockchainService = useBlockchainService();
    return useQuery({
        ...options,
        queryFn: () => options.queryFn(blockchainService, ...args),
        queryKey: options.queryKey(...args),
    });
};
//# sourceMappingURL=query.js.map